import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ParticipateProductSurveyDto, ProductSurvey } from 'washday-sdk';
import { participateProductSurvey } from '../../services/productSurveys.service';
import { useProductSurveyScope } from './session';

export function useParticipateProductSurvey() {
  const scope = useProductSurveyScope();
  const client = useQueryClient();
  return useMutation({
    retry: false,
    mutationFn: async ({ surveyId, dto }: { surveyId: string; dto: ParticipateProductSurveyDto }) => {
      if (!scope.isCurrentSession() || !scope.token) throw new Error('Session changed');
      const response = await participateProductSurvey(surveyId, dto, scope.token);
      if (!scope.isCurrentSession()) throw new Error('Session changed');
      if (!response.data?.data?.id) throw new Error('Invalid participation response');
      return response.data.data;
    },
    onSuccess: async (_result, { surveyId }) => {
      if (!scope.isCurrentSession()) return;
      const queryKey = ['productSurveys', 'active', scope.userId];
      await client.cancelQueries({ queryKey });
      client.setQueriesData<ProductSurvey | null>({ queryKey }, (survey) => survey?._id === surveyId ? null : survey);
      await client.invalidateQueries({ queryKey, refetchType: 'none' });
    },
  });
}
